var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailVerifiyProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 391.57 391.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fdfdfd;\n        opacity: .03;\n      }\n\n      .cls-3 {\n        fill: #e7e7e6;\n        opacity: .54;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-5 {\n        fill: #f1f8f1;\n        opacity: .42;\n      }\n\n      .cls-6 {\n        fill: #dcdcdb;\n        opacity: .85;\n      }\n\n      .cls-7 {\n        fill: #f5f5f4;\n        opacity: .18;\n      }\n\n      .cls-8 {\n        fill: #d7d6d6;\n      }\n\n      .cls-9 {\n        fill: #dbdbda;\n        opacity: .87;\n      }\n\n      .cls-10 {\n        fill: #fff;\n        opacity: 0;\n      }\n\n      .cls-11 {\n        fill: #e6e6e5;\n        opacity: .56;\n      }\n\n      .cls-12 {\n        isolation: isolate;\n      }\n\n      .cls-13 {\n        fill: #f4f3f3;\n        opacity: .21;\n      }\n\n      .cls-14 {\n        fill: #f3f2f2;\n        opacity: .23;\n      }\n\n      .cls-15 {\n        fill: #f6f6f5;\n        opacity: .15;\n      }\n\n      .cls-16 {\n        fill: #efeeee;\n        opacity: .33;\n      }\n\n      .cls-17 {\n        fill: #f9f8f8;\n        opacity: .1;\n      }\n\n      .cls-18 {\n        fill: #d8d8d8;\n        opacity: .95;\n      }\n\n      .cls-19 {\n        fill: #edecec;\n        opacity: .38;\n      }\n\n      .cls-20 {\n        fill: #d9d9d9;\n        opacity: .92;\n      }\n\n      .cls-21 {\n        fill: #e4e3e3;\n        opacity: .64;\n      }\n\n      .cls-22 {\n        fill: #e5e4e4;\n        opacity: .62;\n      }\n\n      .cls-23 {\n        fill: #f7f7f7;\n        opacity: .13;\n      }\n\n      .cls-24 {\n        fill: #e8e8e7;\n        opacity: .51;\n      }\n\n      .cls-25 {\n        fill: #e1e0e0;\n        opacity: .72;\n      }\n\n      .cls-26 {\n        fill: #dddddc;\n        opacity: .82;\n      }\n\n      .cls-27 {\n        fill: #fbfbfb;\n        opacity: .05;\n      }\n\n      .cls-28 {\n        fill: #d7d7d7;\n        opacity: .97;\n      }\n\n      .cls-29 {\n        fill: #e3e2e2;\n        opacity: .67;\n      }\n\n      .cls-30 {\n        fill: #e2e1e1;\n        opacity: .69;\n      }\n\n      .cls-31 {\n        fill: #dfdede;\n        opacity: .77;\n      }\n\n      .cls-32 {\n        fill: #e9e9e8;\n        opacity: .49;\n      }\n\n      .cls-33 {\n        fill: #ebeaea;\n        opacity: .44;\n      }\n\n      .cls-34 {\n        fill: #f0efef;\n        opacity: .31;\n      }\n\n      .cls-35 {\n        fill: #eeeded;\n        opacity: .36;\n      }\n\n      .cls-36 {\n        fill: #f1f0f0;\n        opacity: .28;\n      }\n\n      .cls-37 {\n        fill: #dadada;\n        opacity: .9;\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-39 {\n        fill: #fafaf9;\n        opacity: .08;\n      }\n\n      .cls-40 {\n        fill: #eae9e9;\n        opacity: .46;\n      }\n\n      .cls-41 {\n        fill: #dededd;\n        opacity: .79;\n      }\n\n      .cls-42 {\n        fill: #f2f1f1;\n        opacity: .26;\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-44 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-45 {\n        fill: #ecebeb;\n        opacity: .41;\n      }\n\n      .cls-46 {\n        fill: #e6e5e4;\n        opacity: .59;\n      }\n\n      .cls-47 {\n        fill: #e0dfdf;\n        opacity: .74;\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient);\n        opacity: .11;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 35.27,
    y1: 196.15,
    x2: 355.57,
    y2: 196.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee9330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f37452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 197.89,
    y1: 197.56,
    x2: 281.11,
    y2: 197.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 114.67,
    y1: 197.56,
    x2: 197.89,
    y2: 197.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 114.67,
    y1: 219.42,
    x2: 281.11,
    y2: 219.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 114.67,
    y1: 181.97,
    x2: 281.11,
    y2: 181.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#231f20",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 195.79,
    cy: 195.79,
    r: 195.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 195.42,
    cy: 196.15,
    r: 160.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.89 197.56 281.11 251.32 281.11 143.81 197.89 197.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "114.67 143.81 114.67 251.32 197.89 197.56 114.67 143.81"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m114.67,251.23v.33h166.44s0-.33,0-.33l-77.87-67.15c-3.07-2.65-7.63-2.65-10.7,0l-77.87,67.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m114.67,251.23v.33h166.44s0-.33,0-.33l-77.88-67.03c-3.07-2.64-7.62-2.64-10.69,0l-77.88,67.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m114.67,251.23v.32h166.44s0-.32,0-.32l-77.88-66.92c-3.07-2.64-7.61-2.64-10.68,0l-77.88,66.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m114.67,251.23v.32h166.44s0-.32,0-.32l-77.89-66.8c-3.07-2.63-7.6-2.63-10.67,0l-77.89,66.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m114.67,251.23v.32h166.44s0-.32,0-.32l-77.89-66.69c-3.07-2.63-7.59-2.63-10.65,0l-77.89,66.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m114.67,251.23v.32h166.44s0-.32,0-.32l-77.9-66.57c-3.06-2.62-7.58-2.62-10.64,0l-77.9,66.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m114.67,251.23v.32h166.44s0-.32,0-.32l-77.9-66.46c-3.06-2.61-7.57-2.61-10.63,0l-77.9,66.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m114.67,251.23v.32h166.44s0-.32,0-.32l-77.91-66.34c-3.06-2.61-7.56-2.61-10.62,0l-77.91,66.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m114.67,251.24v.32h166.44s0-.32,0-.32l-77.92-66.23c-3.06-2.6-7.55-2.6-10.61,0l-77.92,66.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m114.67,251.24v.32h166.44s0-.32,0-.32l-77.92-66.11c-3.06-2.59-7.54-2.59-10.6,0l-77.92,66.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m114.67,251.24v.32h166.44s0-.32,0-.32l-77.93-66c-3.05-2.59-7.53-2.59-10.59,0l-77.93,66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m114.67,251.24v.32h166.44s0-.32,0-.32l-77.93-65.88c-3.05-2.58-7.52-2.58-10.57,0l-77.93,65.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m114.67,251.24v.32h166.44s0-.32,0-.32l-77.94-65.77c-3.05-2.57-7.51-2.57-10.56,0l-77.94,65.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m114.67,251.24v.32h166.44s0-.32,0-.32l-77.94-65.65c-3.05-2.57-7.5-2.57-10.55,0l-77.94,65.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m114.67,251.24v.32h166.44s0-.32,0-.32l-77.95-65.54c-3.05-2.56-7.49-2.56-10.54,0l-77.95,65.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m114.67,251.24v.32h166.44s0-.32,0-.32l-77.96-65.42c-3.04-2.56-7.49-2.56-10.53,0l-77.96,65.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m114.67,251.24v.31h166.44s0-.31,0-.31l-77.96-65.31c-3.04-2.55-7.48-2.55-10.52,0l-77.96,65.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m114.67,251.24v.31h166.44s0-.31,0-.31l-77.97-65.19c-3.04-2.54-7.47-2.54-10.51,0l-77.97,65.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m114.67,251.24v.31h166.44s0-.31,0-.31l-77.97-65.08c-3.04-2.54-7.46-2.54-10.49,0l-77.97,65.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m114.67,251.24v.31h166.44s0-.31,0-.31l-77.98-64.96c-3.04-2.53-7.45-2.53-10.48,0l-77.98,64.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m114.67,251.24v.31h166.44s0-.31,0-.31l-77.98-64.85c-3.03-2.52-7.44-2.52-10.47,0l-77.98,64.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m114.67,251.24v.31h166.44s0-.31,0-.31l-77.99-64.74c-3.03-2.52-7.43-2.52-10.46,0l-77.99,64.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m114.67,251.25v.31h166.44s0-.31,0-.31l-78-64.62c-3.03-2.51-7.42-2.51-10.45,0l-78,64.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m114.67,251.25v.31h166.44s0-.31,0-.31l-78-64.51c-3.03-2.5-7.41-2.5-10.44,0l-78,64.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m114.67,251.25v.31h166.44s0-.31,0-.31l-78.01-64.39c-3.03-2.5-7.4-2.5-10.43,0l-78.01,64.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m114.67,251.25v.31h166.44s0-.31,0-.31l-78.01-64.28c-3.02-2.49-7.39-2.49-10.41,0l-78.01,64.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m114.67,251.25v.31h166.44s0-.31,0-.31l-78.02-64.16c-3.02-2.49-7.38-2.49-10.4,0l-78.02,64.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m114.67,251.25v.31h166.44s0-.31,0-.31l-78.02-64.05c-3.02-2.48-7.37-2.48-10.39,0l-78.02,64.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m114.67,251.25v.31h166.44s0-.31,0-.31l-78.03-63.93c-3.02-2.47-7.36-2.47-10.38,0l-78.03,63.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m114.67,251.25v.31h166.44s0-.31,0-.31l-78.04-63.82c-3.02-2.47-7.35-2.47-10.37,0l-78.04,63.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m114.67,251.25v.3h166.44s0-.3,0-.3l-78.04-63.7c-3.01-2.46-7.34-2.46-10.36,0l-78.04,63.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m114.67,251.25v.3h166.44s0-.3,0-.3l-78.05-63.59c-3.01-2.45-7.34-2.45-10.35,0l-78.05,63.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m114.67,251.25v.3h166.44s0-.3,0-.3l-78.05-63.47c-3.01-2.45-7.33-2.45-10.34,0l-78.05,63.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m114.67,251.25v.3h166.44s0-.3,0-.3l-78.06-63.36c-3.01-2.44-7.32-2.44-10.32,0l-78.06,63.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m114.67,251.25v.3h166.44s0-.3,0-.3l-78.06-63.24c-3.01-2.44-7.31-2.44-10.31,0l-78.06,63.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m114.67,251.25v.3h166.44s0-.3,0-.3l-78.07-63.13c-3-2.43-7.3-2.43-10.3,0l-78.07,63.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m114.67,251.25v.3h166.44s0-.3,0-.3l-78.08-63.01c-3-2.42-7.29-2.42-10.29,0l-78.08,63.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m114.67,251.26v.3h166.44s0-.3,0-.3l-78.08-62.9c-3-2.42-7.28-2.42-10.28,0l-78.08,62.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m114.67,251.26v.3h166.44s0-.3,0-.3l-78.09-62.78c-3-2.41-7.27-2.41-10.27,0l-78.09,62.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m114.67,251.26v.3h166.44s0-.3,0-.3l-78.09-62.67c-3-2.4-7.26-2.4-10.26,0l-78.09,62.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m114.67,251.32v.3h166.44s0-.3,0-.3l-78.11-62.3c-2.99-2.38-7.23-2.38-10.22,0l-78.11,62.3Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "114.67 143.46 197.89 220.47 281.11 143.46 114.67 143.46"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerifiyProcess);
export default __webpack_public_path__ + "static/media/emailVerifiyProcess.fd7194276fa23ed2a4614d5cb30cbb9d.svg";
export { ForwardRef as ReactComponent };